<template>
    <div class="pagination-wrapper clearfix row align-items-center no-gutters">
        <div class="pagination-info" :class="paginationInfoClass" v-if="showPaginationInfo" v-html="paginationInfo">
            <!-- Visible Range Text -->
            <!-- <p class="small text-muted m-0">
                {{ collection.get('from') }}-{{ collection.get('to') }} of {{ collection.get('total') }} entries.
            </p> -->
            <!-- Visible Range Text -->
        </div>

        <ul v-if="collection.hasPagination"
            role="navigation"
            class="pagination"
            :class="[{
                'pagination-sm': size == 'small',
                'pagination-lg': size == 'large',
                'justify-content-center': align == 'center',
                'justify-content-end': align == 'right',
            }, paginationComponentClass]"

        >
            <template v-if="collection.shouldRenderLinks">
                <!-- Previous Page -->
                <li class="page-item" :class="{disabled: !collection.hasPreviousPage}">
                    <a rel="prev" aria-label="« Previous" class="page-link" @click.prevent="collection.previousPage()">‹</a>
                </li>
                <!-- Previous Page -->

                <!-- Previous Page -->
                <template v-for="(page, index) in collection.pagination">
                    <li v-if="collection.isCurrentPage(page)" class="page-item active" aria-current="page">
                        <span v-if="loading" class="page-link">
                            <i class="fa fa-circle-notch fa-spin"></i>
                        </span>
                        <span v-else class="page-link">
                            {{ page }}
                        </span>
                    </li>
                    <li v-else class="page-item" :class="{disabled: page === '...'}">
                        <a class="page-link" @click.prevent="collection.page(page)">
                            {{ page }}
                        </a>
                    </li>
                </template>
                <!-- Previous Page -->

                <!-- Next Page -->
                <li class="page-item" :class="{disabled: !collection.hasNextPage}">
                    <a rel="next" aria-label="Next »" class="page-link" @click.prevent="collection.nextPage()">›</a>
                </li>
                <!-- Next Page -->
            </template>

            <!-- Disabled / Loading State -->
            <template v-else>
                <li class="page-item disabled" aria-current="page">
                    <span v-if="loading" class="page-link">
                        <i class="fa fa-circle-notch fa-spin"></i>
                    </span>
                </li>
            </template>
            <!-- Disabled / Loading State -->
        </ul>

        <div class="pagination-perpage" :class="paginationInfoPerPageClass" v-if="showPerPage && collection.hasItems">
            <!-- PerPage Options -->
            <!-- <select class="" v-model="collection.perPage">
                <option v-for="amount in collection.perPageOptions" :value="amount">{{ amount }}</option>
            </select> -->

            <div class="d-flex flex-row justify-content-center justify-content-sm-end align-items-center">
                <div class="prefix d-none d-sm-inline" :class="[prefixPerPageInfo!=''?'pr-2':'' ]" v-html="prefixPerPageInfo"></div>
                <select name="pagination-dropdown" v-model="collection.perPage" aria-controls="pagination-dropdown" class="form-control form-control-sm w-auto">
                    <option v-for="amount in collection.perPageOptions" :value="amount">{{ amount }}</option>
                </select>
                <div class="suffix d-none d-sm-inline" :class="[suffixPerPageInfo!=''?'pl-2':'' ]" v-html="suffixPerPageInfo"></div>
            </div>
            <!-- PerPage Options -->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        collection: {
            type: Object,
            required: true
        },
        loading: {
            type: Boolean,
            required: false
        },
        showPaginationInfo: {
            type: Boolean,
            default: function() {
                return true
            }
        },
        paginationInfoClass: {
            type: String,
            default: function() {
                return 'col col-auto'
            }
        },
        paginationInfoTemplate: {
            type: String,
            default: function() {
                return "{from}-{to} of {total} items."
            }
        },
        paginationInfoNoDataTemplate: {
            type: String,
            default: function() {
                return 'No relevant data'
            }
        },
        size: {
            type: String,
            default: 'default',
            validator: value => {
                return ['small', 'default', 'large'].indexOf(value) !== -1;
            }
        },
        align: {
            type: String,
            default: 'center',
            validator: value => {
                return ['left', 'center', 'right'].indexOf(value) !== -1;
            }
        },
        paginationComponentClass: {
            type: String,
            default: function() {
                return 'col col-auto'
            }
        },
        showPerPage: {
            type: Boolean,
            default: function() {
                return true
            }
        },
        paginationInfoPerPageClass: {
            type: String,
            default: function() {
                return 'col col-auto pr-0'
            }
        },
        paginationInfoPrefixPerPageTemplate: {
            type: String,
            default: function() {
                return ""
            }
        },
        paginationInfoSuffixPerPageTemplate: {
            type: String,
            default: function() {
                return ""
            }
        },
    },
    computed: {
        paginationInfo: function() {
            if (!this.collection.hasItems) {
                return this.replaceTags(this.paginationInfoNoDataTemplate);
            }
            return this.replaceTags(this.paginationInfoTemplate);
        },
        prefixPerPageInfo: function() {
            return this.replaceTags(this.paginationInfoPrefixPerPageTemplate);
        },
        suffixPerPageInfo: function() {
            return this.replaceTags(this.paginationInfoSuffixPerPageTemplate);
        },
    },
    methods: {
        replaceTags: function(txt){
            return txt
                .replace('{from}', this.collection.from || 0)
                .replace('{to}', this.collection.to || 0)
                .replace('{total}', this.collection.total || 0)
                .replace('{current_page}', this.collection.currentPage || 0)
                .replace('{last_page}', this.collection.lastPage || 0);
        },
    }
}
</script>

<style lang="scss" scoped="">
    @import "@styles/_mixins.scss";
    @import '@styles/_theme.scss';
    .pagination-wrapper {
        font-size: .875rem;
        font-family: $pagination-wrapper-font;
        padding: 0;
        @include md {
          padding: $pagination-wrapper-padding;
        }

        @include lg {
          padding: $pagination-wrapper-padding;
        }
        .pagination-info {
        }
        .pagination {
            .page-item {
                .page-link {
                    font-family: $city-font-family;
                    color: $bluey-grey;
                    background: none;
                    border: none;
                    outline: none;
                    box-shadow: none;
                }
                &.active {
                    .page-link {
                        font-family: $city-medium-font-family;
                        color: $midnight-blue;
                    }
                }
            }
        }

        .pagination-perpage {
        }
    }
</style>